export class MotionInitial {
  constructor(
    public opacity: number = 0,
    public x: number = 0,
    public y: number = 50
  ) {}
}

export class MotionEnter {
  constructor(
    public opacity: number = 1,
    public x: number = 0,
    public y: number = 0,
    public transition?: MotionTransition
  ) {}
  getEnterMotion(delay: number = 0): MotionEnter{
    let newTransition = new MotionTransition(30, delay)
    let newEnterMotion = new MotionEnter(1, 0, 0, newTransition);
    return newEnterMotion;
  }
}
export class MotionTransition {
  constructor(public stiffness: number = 30, public delay: number = 0) {}
  
}
